import {isValidDate} from '../../../site/helpers/common/date.mjs';
import {consoleLogRedWhite} from "../../../site/helpers/common/console-log-colors.mjs";

export function tryJson(str) {
  try {
    return JSON.parse(str);
  } catch (e) {
    return null;
  }
}

export const safeJsonStringify = (data) => {
  if (data && (typeof data === 'object' || Array.isArray(data))) {
    try {
      return JSON.stringify(data);
    } catch (e) {
      consoleLogRedWhite(`[Error][safeJsonStringify] Message: ${e?.message}`);
      consoleLogRedWhite(`[Error][safeJsonStringify] Original Date:`, data);
      return null;
    }
  }
  return null;
};

export const safeJsonParse = (jsonString) => {
  if (typeof jsonString === 'string') {
    try {
      return JSON.parse(jsonString);
    } catch (e) {
      consoleLogRedWhite(`[Error][safeJsonParse] Message: ${e?.message}`);
      consoleLogRedWhite(`[Error][safeJsonParse] Invalid JSON String:`, jsonString);
      return null;
    }
  }
  consoleLogRedWhite(`[Error][safeJsonParse] Input is not a valid string:`, jsonString);
  return null;
};


export function convertJsonArrayOfStringsToBullets(jsonArrayOfStrings) {
  // console.log({jsonArrayOfStrings});
  const bulletedList = jsonArrayOfStrings?.map(line => {
    const liLine = `<li>${line}</li>`;
    // console.log(liLine)
    return liLine;
  })?.join('\n');
  // console.log({bulletedList})
  return bulletedList;
}

export function isObject(val) {
  return typeof val === 'object' && !Array.isArray(val) && val !== null;
}

export const fixPropsForJson = (object) => {
  if (typeof object === 'undefined' || object === null) {
    return null;
  }
  if (typeof object !== 'object') {
    return object;
  }
  if (Array.isArray(object)) {
    return object.map(fixPropsForJson);
  }
  return Object.fromEntries(
    Object.entries(object).map(([key, val]) => [
      key,
      val instanceof Date && isValidDate(val)
        ? val.toISOString()
        : isObject(val)
          ? fixPropsForJson(val)
          : Array.isArray(val)
            ? fixPropsForJson(val)
            : val ?? null
    ])
  );
};

export const isObjectEmpty = (obj) => {
  if (typeof obj !== 'object' || obj === null) {
    return false; // Not an object or is null
  }
  return Object.keys(obj)?.length === 0;
};
